import { Address } from './address.model';

export class General {
    public id: number;
    public phone: string;
    public mail: string;
    public url: string;
    public tower: number;
    public floor: number;

    public addresses: Array<Address>;
    public updated: Date;

    constructor() {
        this.id = 0;
        this.addresses = new Array<Address>();
    }
}